<div class="carriers-list-window">
  <div class="carriers-list-window__content">
    <div class="header_actions">
      <input
        placeholder="Search delivery services"
        [(ngModel)]="searchCarrier"
        class="form-input"
        (keyup)="onCarrierSearch($event)" />
    </div>

    <div class="header_actions__ship-countries">
      <div class="grid">
        <span class="header_actions__ship-countries__title">Ship from:</span>
        <pdq-dropdown
          [mode]="'default'"
          width="140"
          [placeholder]="countryCodeDisplayName(countryCode)"
          variant="static"
          [options]="countryOptions"
          (onChange)="onCountryChange($event, 'origin')">
        </pdq-dropdown>
      </div>

      <div class="grid">
        <span class="header_actions__ship-countries__title">Ship to:</span>
        <pdq-dropdown
          [mode]="'default'"
          variant="static"
          width="130"
          [placeholder]="countryCodeDisplayName(countryCode)"
          [options]="countryOptions"
          (onChange)="onCountryChange($event, 'destination')">
        </pdq-dropdown>
      </div>
    </div>

    @if (filteredCarrierList?.length == 0) {
      <div class="display-background">
        <div style="margin: auto">
          <img class="display-background__img" src="assets/images/searchDeliveryService.svg" alt="" />
          <span class="display-background__text">{{ emptyCarrierString }}</span>
        </div>
      </div>
    } @else {
      <mat-grid-list cols="3" rowHeight="115px" [gutterSize]="'8px'">
        @for (carrier of filteredCarrierList; track carrier) {
          <mat-grid-tile class="carrier-button-container">
            <pdq-card [hoverable]="true" color="white" [clickable]="true" (onClick)="openCarrierForm(carrier)"
              ><div class="button-contents">
                <carrier-logo size="small" [carrierName]="carrier.name"></carrier-logo>
                <p class="carrier-item-text">
                  {{ getDisplayName(carrier.name) }}
                </p>
              </div></pdq-card
            >
          </mat-grid-tile>
        }
      </mat-grid-list>
    }
  </div>
</div>
